import { GraphQLQueryClass } from "@harea/component";
import { TTimeOff, TTimeOffsResponse } from "@harea/component";

export class TimeOffsQuery implements GraphQLQueryClass<TTimeOffsResponse, TResponse> {
    public queryKey: string = 'App.harea.timeoff';
    public gql: string = `
        query($pageSize: Float, $page: Float, $data: JSONObject, $sort: [TFilterSort!], $key: String) {
            timeoffs(filter: { data: $data, sort: $sort, pageSize: $pageSize, page: $page, key: $key }) {
                total
                data {
                    id
                    dateBegin
                    dateEnd
                    hourBegin
                    hourEnd
                    title
                    status
                    order
                    entity
                    entityId
                    data
                    dateArchive
                    reason
                    description
                    solde
                    type {
                        id
                        designation
                        isPaid
                    }
                    userCreator {
                        id
                        employee {
                            fullName
                        }
                    }
                    employee {
                        id
                        fullName
                        isAdmin
                        department {
                            id
                            designation                            
                        }
                    }
                    approvals {
                        id
                        approver {
                            id
                            fullName
                        }
                        isApproved
                        isRefused
                    }
                    labels {
                        id
                        value
                        color
                    }
                    files {
                        id
                    }
                    cover {
                        id
                    }
                    isRSVP
                    isRevocked
                    isValidated
                    isClosed
                    isDeadLineRespected
                    isWorkExtension
                    unpaidLeaveMode
                    isExceptionalPaid
                    notificationTime
                    repetition
                    repetitionDateStart
                    repetitionDateEnd
                    meet
                    estimation
                    progression
                    relativePosition
                    overrides {
                        id
                        overrideType
                        dateBegin
                        dateEnd
                        hourBegin
                        hourEnd
                        override { id }
                        overrideTargetDateBegin
                        overrideTargetDateEnd
                        overrideTargetHourBegin
                        overrideTargetHourEnd
                        repetition
                        title
                        status
                        type {
                            id
                            designation
                            isPaid
                        }
                        userCreator {
                            id
                            employee {
                                fullName
                            }
                        }
                        employee {
                            id
                            fullName
                        }
                        approvals {
                            id
                            approver {
                                id
                                fullName
                            }
                            isApproved
                            isRefused
                        }
                        labels {
                            id
                            value
                            color
                        }
                        files {
                            id
                        }
                        isRSVP
                        isRevocked
                        isValidated
                        isClosed
                        isDeadLineRespected
                        isWorkExtension
                        unpaidLeaveMode
                        isExceptionalPaid
                    }
                }
            }
        }
    `;
    public variables?: any;
    constructor(variables?: any) {
        this.variables = variables;
    }
    mapFn(data: TResponse): TTimeOffsResponse {
        return {
            total: data.timeoffs.total,
            data: data.timeoffs.data
        };
    }
}

export type TResponse = {
    timeoffs: {
        total: number,
        data: Array<TTimeOff>
    }
}